import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { paths } from '../paths';

/** «Retour»: previous in-app page when there is one, else the logical parent. */
export function useBack(parent: string = paths.home) {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.key !== 'default') navigate(-1);
    else navigate(parent);
  }, [location.key, navigate, parent]);
}
